import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SidebarData, SidebarData2 } from "./SidebarData";
import SubMenu from "./SubMenu";
import Link from "next/link";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { checkIsNotLogged } from "@/utils/authCheck";
import { useRouter } from 'next/router'; 
import { getUserData } from "@/utils/userData";
import { useState } from 'react';  

const SidebarNav = styled("nav")(({ theme }) => ({
	background: "#fff",
	boxShadow: "0px 4px 20px rgba(47, 143, 232, 0.07)",
	width: "300px",
	padding: "30px 10px",
	height: "100dvh",
	display: "flex",
	flexDirection: "column", // Adaugă asta
	position: "fixed",
	top: 0,
	left: 0,
	transition: "350ms",
	zIndex: "10",
	overflowY: "auto", // Asigură scroll vertical
	boxSizing: "border-box", // Fix scroll bug iOS
	WebkitOverflowScrolling: "touch", // Suport scroll fluid pe iOS
}));

const SidebarWrap = styled("div")(({ theme }) => ({
	width: "100%",
}));

const Sidebar = ({ toogleActive }) => {
     checkIsNotLogged("/");
    
     const router = useRouter();
     const { userData } = getUserData();

	return (
		<>
			<div className='leftSidebarDark'>
				<SidebarNav className='LeftSidebarNav'>
					<SidebarWrap>
						<Box
							sx={{
								mb: "0px",
								px: "20px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center", // Center horizontally
								flexDirection: "column", // Center vertically
							}}
						>
							<Link href='/'>
								<img
									src='/logo.svg'
									alt='Logo'
									className='black-logo'
									height={90}
									style={{
										alignItems: "center",
										display: "flex",
										alignContent: "center",
									}}
								/>
							</Link>

							<IconButton
								onClick={toogleActive}
								size='small'
								sx={{
									background: "rgb(253, 237, 237)",
									display: { lg: "none" },
								}}
							>
								<ClearIcon />
							</IconButton>
						</Box>

                             
                              {userData && userData.admin == 0 && SidebarData2.map((item, index) => {
                                   return <SubMenu item={item} key={index} />;
                              })}
                              {userData && userData.admin > 0 && SidebarData
                                   .filter((item) => !item.adminOnly || userData.admin === 2)
                                   .filter((item) => !userData.colaborator || item.colaboratorAllowed)
                                   .map((item, index) => {
                                        return <SubMenu item={item} key={index} />;
                                   })}
					</SidebarWrap>
				</SidebarNav>
			</div>
		</>
	);
};

export default Sidebar;
